import { render, staticRenderFns } from "./ImportViewLogs.vue?vue&type=template&id=3a037013"
import script from "./ImportViewLogs.vue?vue&type=script&lang=js"
export * from "./ImportViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports